import { mailboxRankChecker, type MailboxInfo } from 'owa-client-types';
import { getCloudEnvironmentForEmailAddress } from '../utils/getCloudEnvironmentForEmailAddress';
import type { CloudEnvironmentInfo } from '../types/CloudEnvironmentInfo';
import { CloudEnvironmentInfoImpl } from '../utils/CloudEnvironmentInfoImpl';
import type { CloudEnvironment } from '../types/CloudEnvironment';
import { pluggableAccountFunctions } from './pluggableAccountFunctions';

export async function getCloudEnvironmentForMailboxInfo(
    mailboxInfo: MailboxInfo
): Promise<CloudEnvironmentInfo> {
    const cloudEnv = await getCloudEnvironmentForMailboxInfoInternal(mailboxInfo);
    return new CloudEnvironmentInfoImpl(cloudEnv);
}

export async function getCloudEnvironmentForMailboxInfoInternal(
    mailboxInfo: MailboxInfo
): Promise<CloudEnvironment> {
    if (pluggableAccountFunctions && !mailboxRankChecker.isCoprincipal(mailboxInfo)) {
        // When given a resource account, try to look up the coprincipal account instead; the coprincipal lookup
        // should hit the cache (since discovery + caching should have been done when that account was created)
        // and coprincipal accounts + resource accounts will be in the same cloud environment
        mailboxInfo =
            pluggableAccountFunctions.getCoprincipalMailboxInfoForMailboxInfo(mailboxInfo) ??
            mailboxInfo;
    }

    // MailboxInfo defines the auth context (userIdentity) and the target resource (mailboxSmtpAddress) for a request;
    // we look up the cloud environment for the target resource since that's where we're trying to go
    return getCloudEnvironmentForEmailAddress(mailboxInfo.mailboxSmtpAddress);
}
